export const FETCH_APY_REQUEST = "FETCH_APY_REQUEST";
export const FETCH_APY_SUCCESS = "FETCH_APY_SUCCESS";
export const FETCH_APY_FAILURE = "FETCH_APY_FAILURE";

export const FETCH_VAULT_SUCCESS = "FETCH_VAULT_SUCCESS";

export const FETCH_TOKENS_SUCCESS = "FETCH_TOKENS_SUCCESS";
